module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Medium-WebXL-4977bd0b6ab52af81923eef62d46c49e.woff2";